export class ApiError extends Error {
  status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  let response: Response
  try {
    response = await fetch(path, {
      credentials: 'same-origin',
      ...init,
      headers: {
        ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
        ...init?.headers,
      },
    })
  } catch {
    throw new ApiError(localizedApiError(path, 0, 'Etwas ist schiefgegangen. Bitte versucht es erneut.'), 0)
  }

  if (!response.ok) {
    let message = 'Etwas ist schiefgegangen. Bitte versucht es erneut.'
    try {
      const body = (await response.json()) as { error?: string }
      if (body.error) message = body.error
    } catch {
      // Keep the friendly fallback for non-JSON proxy errors.
    }
    throw new ApiError(localizedApiError(path, response.status, message), response.status)
  }

  if (response.status === 204) return undefined as T
  return (await response.json()) as T
}
import { localizedApiError } from './i18n'
